export const CARD_DISPLAY_NAME = 'Note';

export const HEADER_CARD_DISPLAY_NAME = 'Heading';

export const EDITOR_SINGLE_LINE_HEIGHT_GRID_UNITS = 3.3;
export const CARD_DEFAULT_HEIGHT_GRID_UNITS = 7;
